module.exports={
	"Form": "DocumentApprovalStateEditManifest",
	"Scope": "DocumentApprovalState-Edit",
	"Descriptors":
	{
		"DocumentApprovalStateDetails.IDDocumentApprovalState":
		{
			"Name": "ID",
			"Hash": "DocStateEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocStateEditIdentity",
				"Group": "DocStateEditIdentity"
			}
		},
		"DocumentApprovalStateDetails.GUIDDocumentApprovalState":
		{
			"Name": "GUID",
			"Hash": "DocStateEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "DocStateEditIdentity",
				"Group": "DocStateEditIdentity"
			}
		},
		"DocumentApprovalStateDetails.Name":
		{
			"Name": "State Name",
			"Hash": "DocStateEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "DocStateEditIdentity",
				"Group": "DocStateEditIdentity"
			}
		},
		"DocumentApprovalStateDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "DocStateEdit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "DocStateEditIdentity",
				"Group": "DocStateEditIdentity"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocStateEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocStateEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
